import API from './api';
import Cookies from 'react-cookies';

const initialize = async() => {
    setTimeout(() => {
        API.call({
            path: '/triggers/initialize'
        }).then(async response => {
            await checkForCommunications();
        }).catch(e => {})
    }, 3e3);
}

const checkForCommunications = async() => { 
    const searchParams = new URLSearchParams(window.location.search),
            trigger = searchParams.get('trigger'),
            communication = searchParams.get('communication');

    if(!trigger || !communication)
        return;

    try {
        const response = await API.call({
            path: '/triggers/communication',
            body: {
                trigger,
                communication
            }
        });

        if(response.success)
            register('communication_open', {
                triggerId: trigger,
                communication_id: parseInt(communication)
            });

        searchParams.delete('trigger');
        searchParams.delete('communication');

        const search = searchParams.toString();

        window.history.replaceState(
            {},
            '',
            `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`
        );

        // window.alert(JSON.stringify({communication, trigger}))
    } catch (e) {
        console.error('Communication tracking error:', e);
    }
}

const register = async(type, details = null) => {
    await API.call({
        path: '/triggers/registerEvent',
        body: {
            type,
            details
        }
    });

    return true;
}

const page_view = details => register('page_view', details),
      modal_open = details => register('modal_open', details);

export default {
    initialize,
    register,


    page_view,
    modal_open
}